angular.module('impactx.cscontract').controller('CSContractSettingsDataCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'BackService',
    'ToolbarService',
    'PartialDialogsService',
    CSContractSettingsDataCtrl
]);

function CSContractSettingsDataCtrl($scope, dataGen, $routeParams, ToastService, BackService, ToolbarService, PartialDialogsService) {
    var self = this;
    self.errorList = [];

    self.save = function ($event) {
        return dataGen.postAsForm($scope, {settingsData: $scope.data}, "/cscontract/settings/save").then(function (data) {
            ToastService.openStandardToastAfterSaveSuccess($scope, data);
            PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.CONTRACT, $routeParams.id, 'cscsettings', $routeParams.preSetId ? $routeParams.preSetId : 0);
        });
    };

    dataGen.getData($scope, {cscId: $routeParams.id}, "/cscontract/settings/view").then(function () {
        defineButtons();
        $scope.initiated = true;
    });

    function hasErrors() {
        return self.errorList.length;
    }

    function getErrors() {
        return self.errorList;
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData,
                    disableExpressions: {valueFunction: hasErrors, errorsFunction: getErrors}
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }
}